import TrainTabsSection from "./TrainTabsSection";

export default TrainTabsSection;
